import { captureIntoContext, } from "@next-platform/packages-ts-types";
import { getAttributionHost } from "./attributionHost";
import { readAttributionContext, writeAttributionContext, } from "./attributionStorage";
/**
 * Thin IO wrapper around the pure `captureIntoContext` reducer:
 * reads the persisted envelope and legacy partner ids, delegates the
 * merge logic to the pure core, then persists the result. Host-neutral
 * consumers (lander, ggpt, RN) can skip this shim and call
 * `captureIntoContext` directly with their own storage.
 */
export async function captureAttributionFromUrl(input) {
    const host = getAttributionHost();
    const parsedUrl = new URL(input.url);
    const existing = await readAttributionContext();
    const legacyPartners = input.legacyPartners;
    // `IAttributionHost.generateAnonymousId` is a one-shot factory —
    // implementers may back it with server-allocated ids, rate-limited
    // token endpoints, or non-idempotent side effects. Only invoke it
    // when no envelope exists yet; otherwise the pure reducer would
    // discard the generated value anyway (`existing.anonymousId` wins).
    const anonymousId = existing === undefined ? host.generateAnonymousId() : existing.anonymousId;
    const { next, isFirstCapture } = captureIntoContext(existing, {
        params: parsedUrl.searchParams,
        landingUrl: input.url,
        referrer: input.referrer,
        cookies: input.cookies,
        now: host.now(),
        anonymousId,
        legacyPartners,
    });
    await writeAttributionContext(next);
    return { context: next, isFirstCapture };
}
